/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    case_alert_templates: [],
    total: 0,
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_CASE_ALERT_TEMPLATES:

            return {
                ...state,
                case_alert_templates: action.payload.data,
                total: action.payload.total_documents,
            }

        default: return state;

    }

}

export default reducer;
